import { render, staticRenderFns } from "./Travaux.vue?vue&type=template&id=49f97e2a&scoped=true&"
import script from "./Travaux.vue?vue&type=script&lang=js&"
export * from "./Travaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f97e2a",
  null
  
)

export default component.exports